__turbopack_context__.v({
  "gridContainer": "Profile-module__oBzwYG__gridContainer",
});
